import useAlias from '@alias';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import EditUserDialog from '../Dialogs/EditUserDialog';

function EditUserButton({ userId }: { userId: string }) {
  const alias = useAlias();
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleClick = () => setDialogOpen(true);

  return (
    <>
      <Tooltip title={alias('Edit User')}>
        <IconButton color='primary' onClick={handleClick}>
          <ModeEditIcon />
        </IconButton>
      </Tooltip>
      {dialogOpen && (
        <EditUserDialog
          open
          onClose={() => setDialogOpen(false)}
          userId={userId}
        />
      )}
    </>
  );
}

export default EditUserButton;
